import { isNil } from 'lodash'

import { Nullable } from '@shared/models/types/primary'

export const sessionStorageGet = <T extends string = string>(
  key: string,
  // eslint-disable-next-line
  fallback: any = null
): T => {
  const item = sessionStorage.getItem(key)

  if (!item) {
    return fallback
  }

  return item as T
}

export const sessionStorageSave = (
  key: string,
  // eslint-disable-next-line
  payload?: Nullable<Record<string, any> | string | any[]>
) => {
  if (isNil(payload)) {
    // eslint-disable-next-line
    console.log('sessionStorage helper: ommiting to set an empty value')
    return
  }

  const valueType = typeof payload

  const stringifyTypes = ['object', 'array']

  if (stringifyTypes.includes(valueType)) {
    sessionStorage.setItem(key, JSON.stringify(payload))
    return
  }

  sessionStorage.setItem(key, `${payload}`)
}

export const sessionStorageRemove = (key: string) =>
  sessionStorage.removeItem(key)

export const sessionStorageHas = (key: string) =>
  sessionStorageGet(key) !== null

export enum SessionStorageKeys {
  SelfShedulerUserInfo = 'selfShedulerUserInfo',
  FaqSearch = 'faqSearch',
  Locale = 'locale',
  SelectedRoute = 'selectedRoute',
  SelectedStrategy = 'selectedStrategy',
  TimerValue = 'timerValue',
  AreTwoRoutesAvailable = 'areTwoRoutesAvailable',
  OncallSortingMode = 'oncallSortingMode',
  QuickFormSortingMode = 'quickFormSortingMode',
  TemplateSortingMode = 'templateSortingMode',
}
